import { render, staticRenderFns } from "./ImportRouteOfAdministrationList.vue?vue&type=template&id=2383ec08&scoped=true&"
import script from "./ImportRouteOfAdministrationList.vue?vue&type=script&lang=js&"
export * from "./ImportRouteOfAdministrationList.vue?vue&type=script&lang=js&"
import style0 from "./ImportRouteOfAdministrationList.vue?vue&type=style&index=0&id=2383ec08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383ec08",
  null
  
)

export default component.exports